import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
  Paper,
  Tabs,
  Tab,
  alpha,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CalculateIcon from "@mui/icons-material/Calculate";
import HirePurchaseTool from "./HirePurchaseTool";
import RepaymentLoading from "./components/RepaymentLoading";
import { IrregularPaymentsTool } from "./irregular-payments";

const HirePurchaseToolDialog = ({
  open,
  onClose,
  caTypeOptions,
  caSettings,
  onAddToHPSchedule,
  hpToolsLoading,
}) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleClose = () => {
    onClose();
  };

  const handleTabChange = (_, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth='lg'
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
          maxHeight: "90vh",
        },
      }}
    >
      <DialogTitle sx={{ p: 0 }}>
        <Paper
          elevation={0}
          sx={{
            p: 3,
            display: "flex",
            alignItems: "center",
            gap: 2,
            bgcolor: (theme) => alpha(theme.palette.primary.main, 0.03),
            borderBottom: "1px solid",
            borderColor: "divider",
          }}
        >
          <Box
            sx={{
              width: 40,
              height: 40,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: 2,
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
            }}
          >
            <CalculateIcon color='primary' />
          </Box>
          <Box flex={1}>
            <Typography variant='h6' fontWeight={600} color='text.primary'>
              HP Repayment & Capital Allowance Generator
            </Typography>
            <Typography variant='body2' color='text.secondary'>
              {activeTab === 0
                ? "Enter the details to generate the HP repayment details"
                : "Plan irregular payments and calculate the effective monthly rate"}
            </Typography>
          </Box>
          <IconButton
            onClick={handleClose}
            sx={{
              color: "text.secondary",
              "&:hover": {
                color: "primary.main",
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Paper>
        {!hpToolsLoading && (
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            sx={{
              px: 3,
              borderBottom: 1,
              borderColor: "divider",
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.01),
            }}
          >
            <Tab label='Regular Payments' />
            <Tab label='Irregular Payments' />
          </Tabs>
        )}
      </DialogTitle>

      <DialogContent sx={{ p: 3, overflow: "auto" }}>
        {hpToolsLoading ? (
          <RepaymentLoading
            title='Importing data to the schedule...'
            description='Please wait while we import the data to the schedule...'
          />
        ) : activeTab === 0 ? (
          <HirePurchaseTool
            onAddToHPSchedule={onAddToHPSchedule}
            caTypeOptions={caTypeOptions}
            caSettings={caSettings}
          />
        ) : (
          <IrregularPaymentsTool
            onAddToHPSchedule={onAddToHPSchedule}
            caTypeOptions={caTypeOptions}
            caSettings={caSettings}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default HirePurchaseToolDialog;
